import { Routes, Route } from 'react-router-dom';
import {
  Home, Basic, Ovace, Advanced, Reports, BasicSupport, Privacy,
  Language, Profile, About, Acronyms, Help, PrivacyPolicy, Feedback
} from '../pages';
import BasicOvace from '../pages/rcp-basic-ovace';

export const AppRoutes = () => {
  return (
    <Routes>
      <Route path="*" element={<Home />} />
      <Route path="/" element={<Home />} />
      <Route path="/basic" element={<BasicSupport />} />
      <Route path="/ovace" element={<Ovace />} />
      <Route path="/basicOvace" element={<BasicOvace />} />
      <Route path="/advanced" element={<Advanced />} />
      <Route path="/reports" element={<Reports preview={{}} />} />
      <Route path="/about" element={<About />} />
      <Route path="/profile" element={<Profile />} />
      <Route path="/language" element={<Language />} />
      <Route path="/acronyms" element={<Acronyms />} />
      <Route path="/help" element={<Help />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/feedback" element={<Feedback />} />
    </Routes>
  );
};
